<template>
  <div>
    <el-dialog
      :visible.sync="show"
      title="Результаты выбора"
      width="70%"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-row>
        <report-result
          ref="reportResultTable"
          :builder-fields="builderFields"
          :builder-relations="builderRelations"
          :builder-search="builderSearch"
        ></report-result>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Закрыть</el-button>
      </div>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator.vue";
import ReportResult from "@/components/report/builder/ReportResult.vue";

export default {
  name: "report-result-modal",
  components: {ReportResult, Paginator},
  props: {
    builderFields:{},
    builderRelations:{},
    builderSearch:{},
  },

  data() {
    return {
      show: false,
      // builderFields:[],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    showModal() {
      this.show = true;

      this.$nextTick(function () {
        this.$refs.reportResultTable.loadReportData(1);
      })
    }
  },

  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  }

}
</script>

<style>

</style>